import joinClasses from "helpers/joinClasses";

export function Number({ children, className="" }) {
    return (
      <h3 className={joinClasses(className,"font-poppins text-6xl")}>
        {children}
      </h3>
    );
  }